"use client";
import Image from "next/image";
import Link from "next/link";
import { useLanguage } from "@/lib/language-context";

export default function Footer() {
  const { t } = useLanguage();
  return (
    <footer className="bg-gray-950 px-4 py-10 text-white">
      <div className="container mx-auto">
        <div className="grid gap-8 md:grid-cols-[1.3fr_0.7fr_0.7fr]">
          <div className="max-w-md">
            <div className="mb-4 flex items-center gap-3">
              <Image
                src="/logo.png"
                alt="BigQuiz Logo"
                width={40}
                height={40}
                className="rounded-lg"
              />
              <span className="text-xl font-bold">BigQuiz</span>
            </div>
            <p className="leading-7 text-gray-400">{t("footer.description")}</p>
          </div>

          <div>
            <h3 className="font-semibold mb-4">{t("footer.game")}</h3>
            <ul className="space-y-2 text-gray-400">
              <li>
                <Link href="#" className="hover:text-white transition-colors">
                  {t("footer.howToPlay")}
                </Link>
              </li>
              <li>
                <Link href="#" className="hover:text-white transition-colors">
                  {t("footer.categories")}
                </Link>
              </li>
              <li>
                <Link href="#" className="hover:text-white transition-colors">
                  {t("footer.leaderboards")}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold mb-4">{t("footer.legal")}</h3>
            <ul className="space-y-2 text-gray-400">
              <li>
                <Link
                  href="/confidentiality"
                  className="hover:text-white transition-colors"
                >
                  {t("footer.privacy")}
                </Link>
              </li>
              <li>
                <Link
                  href="/data"
                  className="hover:text-white transition-colors"
                >
                  Data
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 border-t border-gray-800 pt-8 text-center text-gray-400">
          <p>
            &copy; {new Date().getFullYear()} BigQuiz. {t("footer.copyright")}
          </p>
        </div>
      </div>
    </footer>
  );
}
